import { ja } from './locales/ja';
import { en } from './locales/en';

export type Language = 'ja' | 'en';
export type TranslationKeys = typeof ja;

// 現在の言語
let currentLanguage: Language = 'ja';

// 翻訳オブジェクト
const translations = {
  ja,
  en,
};

// 言語を設定
export const setLanguage = (lang: Language) => {
  currentLanguage = lang;
  localStorage.setItem('sorarium-language', lang);
};

// 現在の言語を取得
export const getLanguage = (): Language => {
  return currentLanguage;
};

// 初期化（localStorageから言語設定を読み込み）
export const initializeLanguage = () => {
  const savedLang = localStorage.getItem('sorarium-language') as Language;
  if (savedLang && (savedLang === 'ja' || savedLang === 'en')) {
    currentLanguage = savedLang;
  } else {
    // ブラウザの言語設定から判定
    const browserLang = navigator.language.toLowerCase();
    currentLanguage = browserLang.startsWith('ja') ? 'ja' : 'en';
  }
};

// 翻訳を取得
export const t = (key: string): string => {
  const keys = key.split('.');
  let value: any = translations[currentLanguage];
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      // キーが見つからない場合は日本語にフォールバック
      value = translations.ja;
      for (const fallbackKey of keys) {
        if (value && typeof value === 'object' && fallbackKey in value) {
          value = value[fallbackKey];
        } else {
          return key; // それでも見つからない場合はキーをそのまま返す
        }
      }
      break;
    }
  }
  
  // 配列の場合はランダムに選択
  if (Array.isArray(value)) {
    return value[Math.floor(Math.random() * value.length)];
  }
  
  return typeof value === 'string' ? value : key;
};

// useTranslationフックはLanguageContext.tsxから提供される